/**
 * https://github.com/tjunghans/jquery.distinct
 */
(function ($) {
	'use strict';

	$.extend({
		distinct: function (anArray) {
			var result = [];
			$.each(anArray, function (i, v) {
				if ($.inArray(v, result) === -1) {
					result.push(v);
				}
			});
			return result;
		}
	});
}(window.jQuery));



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/utils/jquery.distinct.js
// module id = 73
// module chunks = 0